import React from 'react';

export default function SessionExpiredPage() {
  return (
    <main style={{ fontFamily: 'Inter, sans-serif', padding: '24px' }}>
      <h1>Hello World</h1>
      <p>Session expired page shell (Phase 1C).</p>
    </main>
  );
}
